import { render, staticRenderFns } from "./CartRecommend.vue?vue&type=template&id=4fce5f91"
import script from "./CartRecommend.vue?vue&type=script&lang=js"
export * from "./CartRecommend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports